import { createLazyComponent, LazyModule } from 'owa-bundling';
import PlaceholderPreviewPane from './components/PlaceholderPreviewPane';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "PreviewPane" */ './lazyIndex');
});
// Delayed Loaded Components
export var PreviewPane = createLazyComponent(lazyModule, function (m) { return m.PreviewPane; }, PlaceholderPreviewPane);
//# sourceMappingURL=index.js.map